import { indexTransactionsOperation } from "@api/services/transactions"

const listProjectTransactions = async (request, projectId) => {
  const { data: projectTransactions } = await request(indexTransactionsOperation, { projectId })

  return projectTransactions
}

export default listProjectTransactions
